var map = {
	"./services/InterfaceConfigurationPage.js": "xBcp"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "mV3P";


//////////////////
// WEBPACK FOOTER
// ./src/api ^\.\/.+\/.+\.js$
// module id = mV3P
// module chunks = 1